import React from "react";
import Text, {
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SIZE,
} from "@gc-npm/components.text";

const Card = (props) => {
  const { title, description, index } = props;

  return (
    <>
      <div className="text-card-container" key={index}>
        <Text
          text={title}
          kind={TEXT_KIND.HEADING}
          level={TEXT_HEADING_LEVEL.H3}
          align={TEXT_ALIGN.LEFT}
          size={TEXT_SIZE.TITLE6}
          fontType={TEXT_FONT_WEIGHT.BOLD}
          className="text-card-title"
        />

        <Text
          text={description}
          kind={TEXT_KIND.div}
          align={TEXT_ALIGN.LEFT}
          size={TEXT_SIZE.CAPTION1}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
          className="text-card-description"
        />
      </div>

      <style jsx>{`
     
      `}</style>
    </>
  );
};

export default Card;
